import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/mes-annonces/MesAnnonces.css";
import useArticles from "../../hooks/useArticle";
import { formatPrice } from "../../utils/formatPrice";
import { imageArticleUrl } from "../../utils/modules";
import Breadcrumb from "../../components/breadcrumb/Breadcrumb";
import LoaderArticleListe from "../../components/loader/article/LoaderArticleListe";
import noImage from "../../assets/images/articles/no-photo.png";

export default function MesAnnonces({ setAlert }) {
  const navigate = useNavigate();

  const [filter, setFilter] = useState("all");

  // data state
  const [articles, setArticles] = useState([]);
  const [loadingArticle, setLoadingArticle] = useState(false);
  const [showVenduModal, setShowVenduModal] = useState(false);
  const [articleVendu, setArticleVendu] = useState(null);
  const [articlePlusInteresse, setArticlePlusInteresse] = useState(null);
  const [showPlusInteresseModal, setShowPlusInteresseModal] = useState(false);
  const [showQualifModal, setShowQualifModal] = useState(false);
  const [articleToQualify, setArticleToQualify] = useState(null);
  const [qualifyingLoading, setQualifyingLoading] = useState(false);
  const [contactEntries, setContactEntries] = useState({});
  const [qualifFilter, setQualifFilter] = useState("pending");

  const CANAL_CONTACT = {
    APPEL: 1,
    WHATSAPP: 2,
    MESSAGE: 3,
  };

  const CANAL_LABELS = {
    [CANAL_CONTACT.APPEL]: {
      label: "Appel téléphonique",
      icon: "bi-telephone",
    },
    [CANAL_CONTACT.WHATSAPP]: { label: "WhatsApp", icon: "bi-whatsapp" },
    [CANAL_CONTACT.MESSAGE]: {
      label: "Message sur le site",
      icon: "bi-chat-dots",
    },
  };

  const CANAL_ICON_MAP = {
    [CANAL_CONTACT.APPEL]: "bi-telephone",
    [CANAL_CONTACT.WHATSAPP]: "bi-whatsapp",
    [CANAL_CONTACT.MESSAGE]: "bi-chat-dots",
  };

  const CANAL_LABEL_MAP = {
    [CANAL_CONTACT.APPEL]: "Appel téléphonique",
    [CANAL_CONTACT.WHATSAPP]: "WhatsApp",
    [CANAL_CONTACT.MESSAGE]: "Message sur le site",
  };

  // pagination state
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const LIMIT = 10;

  const {
    findAllArticlesForCategory,
    updateArticleStatus,
    updateArticleCounter,
    getArticleContactEntries,
    qualifyContactEntry,
  } = useArticles();

  const getCanalStats = (a) => [
    // {
    //   canal: CANAL_CONTACT.APPEL,
    //   label: "Appel téléphonique",
    //   icon: "bi-telephone",
    //   total: a.nbAppelCount || 0,
    //   confirme: a.nbContactConfirmeAppelCount || 0,
    // },
    // {
    //   canal: CANAL_CONTACT.WHATSAPP,
    //   label: "WhatsApp",
    //   icon: "bi-whatsapp",
    //   total: a.nbWhatsappCount || 0,
    //   confirme: a.nbContactConfirmeWhatsappCount || 0,
    // },
    // {
    //   canal: CANAL_CONTACT.MESSAGE,
    //   label: "Message sur le site",
    //   icon: "bi-chat-dots",
    //   total: a.nbMessageCount || 0,
    //   confirme: a.nbContactConfirmeMessageCount || 0,
    // },

    {
      canal: CANAL_CONTACT.VUE,
      label: "Vue",
      icon: "bi-eye",
      total: a.nbVueCount || 0,
      qualifie: 0,
      aQualifier: 0,
    },
    {
      canal: CANAL_CONTACT.FAVORIS,
      label: "Favori",
      icon: "bi-heart",
      total: a.nbFavorisCount || 0,
      qualifie: 0,
      aQualifier: 0,
    },
    {
      canal: CANAL_CONTACT.APPEL,
      label: "Appel téléphonique",
      icon: "bi-telephone",
      total: a.nbAppelCount || 0,
      qualifie: a.nbAppelQualifieCount || 0,
      aQualifier: a.nbAppelAQualifierCount || 0,
    },
    {
      canal: CANAL_CONTACT.MESSAGE,
      label: "Message sur le site",
      icon: "bi-chat-dots",
      total: a.nbMessageCount || 0,
      qualifie: a.nbMessageQualifieCount || 0,
      aQualifier: a.nbMessageAQualifierCount || 0,
    },
    {
      canal: CANAL_CONTACT.WHATSAPP,
      label: "WhatsApp",
      icon: "bi-whatsapp",
      total: a.nbWhatsappCount || 0,
      qualifie: a.nbWhatsAppQualifieCount || 0,
      aQualifier: a.nbWhatsAppAQualifierCount || 0,
    },
    
  ];

  const getRemainingToQualify = (a) => a.nbAQualifierCount || 0;

  const goToVisualisation = (articleId) => {
    navigate(`/article/visualisation/${articleId}`);
  };

  const currentUser = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  }, []);
  const userId = currentUser?._id;

  const breadcrumbItems = useMemo(
    () => [
      { label: "Accueil", link: "/" },
      { label: "Mon compte", link: "/utilisateur/compte" },
      { label: "Mes annonces" },
    ],
    [],
  );

  // Helpers image
  const formatPhotoPath = (p) => (p || "").replace(/\\/g, "/");
  const buildPhotoUrl = (storedPath) => {
    const p = formatPhotoPath(storedPath);
    if (!p) return "";
    if (p.startsWith("http://") || p.startsWith("https://")) return p;

    const idx = p.indexOf("files/");
    const relative = idx !== -1 ? p.slice(idx) : p;
    return `${imageArticleUrl}/${relative}`;
  };

  // Chargement paginé
  useEffect(() => {
    if (!userId) return;

    setLoadingArticle(true);

    const ninetyDaysAgo = new Date();
    ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 90);

    const filtersParams = {
      userId,
      archive: 2,
      status: 1,
      limit: LIMIT,
      sort: "-createdAt",
      dateExpirationAfter: ninetyDaysAgo,
    };

    findAllArticlesForCategory(page, filtersParams)
      .then((res) => {
        const data = res?.data || [];
        const total = Number(res?.total || 0);
        setArticles(Array.isArray(data) ? data : []);
        setTotalPages(Math.max(1, Math.ceil(total / LIMIT)));
        setLoadingArticle(false);
      })
      .catch((err) => {
        setLoadingArticle(false);
        console.log(err);
        setArticles([]);
        setTotalPages(1);
        setAlert?.({
          message:
            "Une erreur s'est produite lors du chargement de vos annonces.",
          type: "danger",
        });
      });
  }, [userId, page]);

  // Filtre local (sur la page actuelle)
  const annonces = useMemo(() => {
    if (filter === "all") return articles;

    if (filter === "particulier") {
      return articles.filter((a) => Number(a.typeAbonnement) === 2);
    }

    if (filter === "pro") {
      return articles.filter((a) => Number(a.typeAbonnement) === 1);
    }

    if (filter === "test") {
      return articles.filter((a) => Number(a.isTest) === 1);
    }

    return articles;
  }, [filter, articles]);

  const getDateLabel = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    const now = new Date();

    const sameDay =
      d.getDate() === now.getDate() &&
      d.getMonth() === now.getMonth() &&
      d.getFullYear() === now.getFullYear();

    const yesterday = new Date(now);
    yesterday.setDate(now.getDate() - 1);

    const isYesterday =
      d.getDate() === yesterday.getDate() &&
      d.getMonth() === yesterday.getMonth() &&
      d.getFullYear() === yesterday.getFullYear();

    if (sameDay) return "Aujourd'hui";
    if (isYesterday) return "Hier";
    return d.toLocaleDateString("fr-FR");
  };

  const getArticleStatus = (a) => {
    const now = new Date();
    const expirationDate = new Date(a.dateExpiration);

    const daysSinceExpiration = (now - expirationDate) / (1000 * 60 * 60 * 24);

    const isExpired = expirationDate < now && daysSinceExpiration <= 90;

    const isBoostActive = a.validiteBoost && new Date(a.validiteBoost) > now;

    const isNotInterrestAnymore = a.status === 4;

    if (isNotInterrestAnymore) {
      return { type: "notInterrestAnymore", label: "PLUS INTERESSÉ" };
    }

    if (a.adminApprouved === 0) {
      return { type: "expired", label: "NON APPROUVÉ" };
    }

    if (a.adminApprouved === 2) {
      return { type: "pending", label: "EN ATTENTE DE VALIDATION" };
    }

    if (isExpired) {
      return { type: "expired", label: "ABONNEMENT EXPIRÉ" };
    }

    if (isBoostActive) {
      return { type: "boosted", label: "BOOSTÉ" };
    }

    return null;
  };

  // Pagination UI
  const canPrev = page > 1;
  const canNext = page < totalPages;

  const goPrev = () => canPrev && setPage((p) => p - 1);
  const goNext = () => canNext && setPage((p) => p + 1);
  const goToPage = (p) => setPage(Math.min(Math.max(1, p), totalPages));

  const pageNumbers = useMemo(() => {
    // pagination compacte: 1 … p-1 p p+1 … last
    const total = totalPages;
    const p = page;

    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);

    const set = new Set([1, 2, total - 1, total, p - 1, p, p + 1]);
    const arr = [...set]
      .filter((n) => n >= 1 && n <= total)
      .sort((a, b) => a - b);

    const out = [];
    for (let i = 0; i < arr.length; i++) {
      out.push(arr[i]);
      if (i < arr.length - 1 && arr[i + 1] - arr[i] > 1) out.push(null);
    }
    return out;
  }, [page, totalPages]);

  if (!userId) {
    return (
      <div className="maPage">
        <div className="container">
          <div className="maEmpty">
            Vous devez être connecté pour voir vos annonces.
          </div>
        </div>
      </div>
    );
  }

  const updateStatusVendu = async (articleId, status) => {
    await updateArticleStatus(articleId, "status", status)
      .then(() => {
        setArticles((prev) =>
          prev.map((a) =>
            a._id === articleVendu._id ? { ...a, status: 3 } : a,
          ),
        );
        setAlert?.({
          message: "Annonce marquée comme vendue.",
          type: "success",
        });
      })
      .catch((err) => {
        console.log(err);
        setAlert?.({
          message:
            "Une erreur s'est produite lors de la mise à jour de l'annonce.",
          type: "danger",
        });
      })
      .finally(() => {
        setShowVenduModal(false);
        setArticleVendu(null);
      });
  };

  const handleQualifyContact = async (canal) => {
    if (!articleToQualify) return;
    setQualifyingLoading(true);

    const fieldMap = {
      [CANAL_CONTACT.APPEL]: "nbContactConfirmeAppelCount",
      [CANAL_CONTACT.WHATSAPP]: "nbContactConfirmeWhatsappCount",
      [CANAL_CONTACT.MESSAGE]: "nbContactConfirmeMessageCount",
    };

    try {
      await updateArticleCounter(articleToQualify._id, "nbContactConfirme", {
        canal,
      });

      setArticles((prev) =>
        prev.map((a) =>
          a._id === articleToQualify._id
            ? {
              ...a,
              [fieldMap[canal]]: (a[fieldMap[canal]] || 0) + 1,
            }
            : a,
        ),
      );

      // 🔥 Met à jour l'article affiché dans le modal pour recalculer les restes en direct
      setArticleToQualify((prev) => ({
        ...prev,
        [fieldMap[canal]]: (prev[fieldMap[canal]] || 0) + 1,
      }));

      setAlert?.({ message: "Contact confirmé avec succès.", type: "success" });
    } catch (err) {
      console.log(err.response);
      setAlert?.({
        message: "Une erreur s'est produite lors de la confirmation.",
        type: "danger",
      });
    } finally {
      setQualifyingLoading(false);
    }
  };

  const openQualifModal = async (a) => {
    setArticleToQualify(a);
    setShowQualifModal(true);
    const res = await getArticleContactEntries(a._id);
    setContactEntries(res?.data || {});
  };

  const handleQualifyEntry = async (field, entryId, statut) => {
    const canal = { nbAppel: 1, nbWhatsapp: 2, nbMessage: 3 }[field];
    try {
      await qualifyContactEntry(articleToQualify._id, canal, entryId, statut);

      const updatedEntries = {
        ...contactEntries,
        [field]: contactEntries[field].map((e) =>
          e._id === entryId ? { ...e, statutQualification: statut } : e,
        ),
      };
      setContactEntries(updatedEntries);

      const remaining = ["nbAppel", "nbWhatsapp", "nbMessage"].reduce(
        (sum, f) =>
          sum +
          (updatedEntries[f] || []).filter((e) => e.statutQualification === 0)
            .length,
        0,
      );

      setArticles((prev) =>
        prev.map((a) =>
          a._id === articleToQualify._id
            ? { ...a, nbAQualifierCount: remaining }
            : a,
        ),
      );
    } catch (err) {
      setAlert?.({
        message: "Erreur lors de la qualification.",
        type: "danger",
      });
    }
  };

  const buildEntryQuestion = (field, entry) => {
    const contactName = entry.utilisateur
      ? `${entry.utilisateur.nom || ""} ${entry.utilisateur.prenom || ""}`.trim()
      : null;
    const contactPhone = entry.utilisateur?.tel;

    const qui = entry.utilisateur
      ? contactName || contactPhone || "un utilisateur"
      : "Un visiteur anonyme";

    const verbeMap = {
      nbAppel: "vous a appelé",
      nbWhatsapp: "vous a contacté sur WhatsApp",
      nbMessage: "vous a envoyé un message",
    };

    return `${qui} ${verbeMap[field]}${contactPhone ? ` (${contactPhone})` : ""}`;
  };

  const getFilteredEntries = () => {
    const all = ["nbAppel", "nbWhatsapp", "nbMessage"].flatMap((field) =>
      (contactEntries[field] || []).map((entry) => ({ ...entry, field })),
    );
    all.sort((a, b) => new Date(b.date) - new Date(a.date));
    if (qualifFilter === "pending")
      return all.filter(
        (e) => e.statutQualification === 0 || !e.statutQualification,
      );
    if (qualifFilter === "qualified")
      return all.filter((e) => e.statutQualification === 1);
    if (qualifFilter === "rejected")
      return all.filter((e) => e.statutQualification === 2);
    return all;
  };

  return (
    <div className="maPage">
      <div className="container">
        <div className="maBreadcrumbWrap">
          <Breadcrumb items={breadcrumbItems} />
        </div>

        <div className="maTabs">
          <button
            className={`maTab ${filter === "all" ? "active" : ""}`}
            onClick={() => {
              setFilter("all");
              setPage(1);
            }}
            type="button"
          >
            Toutes
          </button>

          <button
            className={`maTab ${filter === "particulier" ? "active" : ""}`}
            onClick={() => {
              setFilter("particulier");
              setPage(1);
            }}
            type="button"
          >
            Particulières
          </button>

          <button
            className={`maTab ${filter === "pro" ? "active" : ""}`}
            onClick={() => {
              setFilter("pro");
              setPage(1);
            }}
            type="button"
          >
            Professionnels
          </button>
          {currentUser?.typeCompte === 3 && (
            <>
              <button
                className={`maTab ${filter === "test" ? "active" : ""}`}
                onClick={() => {
                  setFilter("test");
                  setPage(1);
                }}
                type="button"
              >
                Test
              </button>
            </>
          )}
        </div>

        <div className="maList">
          {loadingArticle ? (
            <LoaderArticleListe />
          ) : annonces.length === 0 ? (
            <div className="maEmpty">Aucune annonce pour ce filtre.</div>
          ) : (
            annonces.map((a) => {
              const img = a.photos?.[0]
                ? buildPhotoUrl(a.photos[0]) + `?v=${Date.now()}`
                : noImage;

              const status = getArticleStatus(a);

              const d = a.createdAt ? new Date(a.createdAt) : null;
              const time = d
                ? d.toLocaleTimeString("fr-FR", {
                  hour: "2-digit",
                  minute: "2-digit",
                })
                : "";

              const now = new Date();
              const expirationDate = new Date(a.dateExpiration);

              const daysSinceExpiration =
                (now - expirationDate) / (1000 * 60 * 60 * 24);

              const isAbonnementExpired =
                expirationDate < now && daysSinceExpiration <= 90;

              const isAdminApprouved = a.adminApprouved === 1;

              const canReabonner =
                isAdminApprouved &&
                isAbonnementExpired &&
                daysSinceExpiration <= 90 &&
                a.archive === 2;

              return (
                <div
                  key={a._id}
                  className="maRow"
                  role="button"
                  tabIndex={0}
                  onMouseDown={(e) => e.currentTarget.focus()}
                  onClick={() => goToVisualisation(a._id)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      goToVisualisation(a._id);
                  }}
                  style={{ position: "relative" }}
                >
                  <div className="maDate">
                    <div className="maDateLabel">
                      {getDateLabel(a.createdAt)}
                    </div>
                    <div className="maTime">{time}</div>
                  </div>

                  <div className="maThumbWrap">
                    <img className="maThumb" src={img} alt={a.titre} />
                  </div>

                  <div className="maContent">
                    <div className="maTitle">{a.titre}</div>
                    <div className="maMeta">{a.idCategorie?.nom || "—"}</div>
                    <div className="maMeta">
                      {a.quartier ? `${a.quartier} / ` : ""}
                      {a.ville}
                    </div>
                    {a?.prix && a.prix > 0 ? (
                      <div className="maPrice">{formatPrice(a.prix)} MGA</div>
                    ) : null}

                    <div className="mt-2">
                      <a
                        className="category_item"
                        style={{ padding: "0px" }}
                        onClick={(ev) => {
                          ev.stopPropagation();
                          ev.preventDefault();
                          navigate(`/article/visualisation/${a._id}?step=2`);
                        }}
                      >
                        tableau de bord
                      </a>
                    </div>

                    {(() => {
                      const totalContacts =
                        (a.nbAppelCount || 0) +
                        (a.nbWhatsAppCount || 0) +
                        (a.nbMessageCount || 0);
                      const remaining = getRemainingToQualify(a);
                      const canalStats = getCanalStats(a);
                      const partagesWhatsapp = (a.nbPartageWathsapp || []).length;
                      const partagesFacebook = (a.nbPartageFacebook || []).length;
                      const totalQualifie =
                        (a.nbAppelQualifieCount || 0) +
                        (a.nbWhatsappQualifieCount || 0) +
                        (a.nbMessageQualifieCount || 0);

                      return (
                        <div
                          className="maQualifBox"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div className="maStatsRow">
                            {canalStats.map((c) => (
                              <span
                                className="maStatPill"
                                key={c.canal}
                                title={`${c.label})`}
                              >
                                <i className={`bi ${c.icon}`} />
                                {c.total}
                              </span>
                            ))}

                            {/* <span className="maStatSep" />

                            <span className="maStatPill" title="Vues">
                              <i className="bi bi-eye" /> {a.nbVueCount || 0}
                            </span>
                            <span className="maStatPill" title="Favoris">
                              <i className="bi bi-heart" /> {a.nbFavorisCount || 0}
                            </span> */}
                            {/* <span className="maStatPill" title="Partages WhatsApp">
                              <i className="bi bi-whatsapp" /> {partagesWhatsapp}
                            </span>
                            <span className="maStatPill" title="Partages Facebook">
                              <i className="bi bi-facebook" /> {partagesFacebook}
                            </span> */}

                            {/* <span className="maStatSep" /> */}

                            {/* <span className="maStatPill maStatPillStrong" title="Contacts qualifiés">
                              <i className="bi bi-check2-circle" /> {totalQualifie}
                            </span> */}
                            {/* <span className="maStatPill maStatPillWarn" title="Contacts à qualifier">
                              <i className="bi bi-question-circle" /> {remaining}
                            </span> */}
                          </div>

                          {totalContacts > 0 && (
                            <button
                              type="button"
                              className={`maQualifBtn ${remaining === 0 ? "maQualifBtnDone" : ""}`}
                              onClick={() => openQualifModal(a)}
                            >
                              {remaining > 0 ? (
                                <>
                                  <i className="bi bi-plus-circle" /> {remaining} à confirmés
                                </>
                              ) : (
                                <>
                                  <i className="bi bi-check2-circle" /> Tout confirmés — modifier
                                </>
                              )}
                            </button>
                          )}
                        </div>
                      );
                    })()}
                    <div className="maActionsBottom">
                      {status?.type === "expired" &&
                        a?.status != 3 &&
                        canReabonner &&
                        status?.type != "notInterrestAnymore" && (
                          <>
                            <button
                              className="btn btn_reabonner"
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate(
                                  `/article/abonnement/paiement?type=2&&id=${a._id}`,
                                );
                              }}
                              style={{ marginTop: 8 }}
                            >
                              Republier
                            </button>
                            <button
                              className="btn btn_not_interested"
                              onClick={(e) => {
                                e.stopPropagation();
                                setArticlePlusInteresse(a);
                                setShowPlusInteresseModal(true);
                              }}
                              style={{ marginTop: 8, marginLeft: 8 }}
                            >
                              Plus interessé
                            </button>

                            <button
                              className="btn btn_vendu"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setShowVenduModal(true);
                                setArticleVendu(a);
                              }}
                              style={{ marginTop: 8, marginLeft: 8 }}
                            >
                              Vendu
                            </button>
                          </>
                        )}
                      {a?.status != 3 &&
                        a?.status != 4 &&
                        isAdminApprouved &&
                        status?.type !== "expired" && (
                          <button
                            className="btn btn_vendu"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setShowVenduModal(true);
                              setArticleVendu(a);
                            }}
                            style={{ marginTop: 8 }}
                          >
                            VENDU
                          </button>
                        )}
                    </div>
                  </div>

                  <div className="listeStatus">
                    {status?.type === "notInterrestAnymore" && (
                      <div className="text_not_interrest">{status.label}</div>
                    )}

                    {a?.status != 3 && status?.type === "expired" && (
                      <div className="text_abonnement_expirer">
                        {status.label}
                      </div>
                    )}

                    {status?.type === "rejected" && (
                      <div className="text_admin_rejected">{status.label}</div>
                    )}

                    {status?.type === "pending" && (
                      <div className="text_admin_pending">{status.label}</div>
                    )}

                    {status?.type === "boosted" && (
                      <div className="text_boost">{status.label}</div>
                    )}
                    {a?.status == 3 && isAdminApprouved && (
                      <div className="text_vendu">VENDU</div>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>

        {/* PAGINATION EN BAS */}
        {!loadingArticle &&
          totalPages > 1 &&
          (page > 1 || annonces.length >= 10) && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                padding: "16px 0 4px",
                flexWrap: "wrap",
              }}
            >
              <button
                type="button"
                className="maTab"
                onClick={goPrev}
                disabled={!canPrev}
                style={
                  !canPrev ? { opacity: 0.55, cursor: "default" } : undefined
                }
              >
                ← Précédent
              </button>

              {pageNumbers.map((n, idx) =>
                n === null ? (
                  <span key={`dots-${idx}`} style={{ opacity: 0.7 }}>
                    …
                  </span>
                ) : (
                  <button
                    key={n}
                    type="button"
                    className={`maTab ${page === n ? "active" : ""}`}
                    onClick={() => goToPage(n)}
                  >
                    {n}
                  </button>
                ),
              )}

              <button
                type="button"
                className="maTab"
                onClick={goNext}
                disabled={!canNext}
                style={
                  !canNext ? { opacity: 0.55, cursor: "default" } : undefined
                }
              >
                Suivant →
              </button>
            </div>
          )}
      </div>
      {showVenduModal && articleVendu && (
        <div className="modal_vendu">
          <div className="modal_vendu_content">
            <h2>Confirmer la vente</h2>
            <p>Êtes-vous sûr de vouloir marquer cette annonce comme vendue ?</p>
            <div className="modal_vendu_actions">
              <button
                className="btn btn_confirm"
                onClick={() => {
                  updateStatusVendu(articleVendu._id, 3);
                }}
              >
                Oui, c'est vendu
              </button>
              <button
                className="btn btn_cancel"
                onClick={() => setShowVenduModal(false)}
              >
                Non, annuler
              </button>
            </div>
          </div>
        </div>
      )}

      {showPlusInteresseModal && articlePlusInteresse && (
        <div className="modal_vendu">
          <div className="modal_vendu_content">
            <h2>Confirmer l'intérêt</h2>
            <p>
              Êtes-vous sûr de vouloir marquer cette annonce comme plus
              intéressante ?
            </p>
            <div className="modal_vendu_actions">
              <button
                className="btn btn_confirm"
                onClick={() => {
                  updateStatusVendu(articlePlusInteresse._id, 4);
                }}
              >
                Oui, c'est plus intéressante
              </button>
              <button
                className="btn btn_cancel"
                onClick={() => setShowPlusInteresseModal(false)}
              >
                Non, annuler
              </button>
            </div>
          </div>
        </div>
      )}

      {showQualifModal && articleToQualify && (
        <div
          className="modal_vendu"
          onClick={() => {
            if (!qualifyingLoading) {
              setShowQualifModal(false);
              setArticleToQualify(null);
            }
          }}
        >
          <div
            className="modal_vendu_content"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>Confirmer les contacts reçus</h2>
            <p>
              Pour « <strong>{articleToQualify.titre}</strong> », confirmez les
              contacts que vous avez réellement reçus.
            </p>

            <div className="maQualifFilterTabs">
              {[
                { key: "pending", label: "À confirmés" },
                { key: "qualified", label: "Confirmés" },
                { key: "rejected", label: "Non confirmés" },
                { key: "all", label: "Tous" },
              ].map((f) => {
                const count = (() => {
                  const all = ["nbAppel", "nbWhatsapp", "nbMessage"].flatMap(
                    (field) => contactEntries[field] || [],
                  );
                  if (f.key === "pending")
                    return all.filter(
                      (e) =>
                        !e.statutQualification || e.statutQualification === 0,
                    ).length;
                  if (f.key === "qualified")
                    return all.filter((e) => e.statutQualification === 1)
                      .length;
                  if (f.key === "rejected")
                    return all.filter((e) => e.statutQualification === 2)
                      .length;
                  return all.length;
                })();

                return (
                  <button
                    key={f.key}
                    type="button"
                    className={`maQualifFilterTab ${qualifFilter === f.key ? "active" : ""}`}
                    onClick={() => setQualifFilter(f.key)}
                  >
                    {f.label}{" "}
                    <span className="maQualifFilterTabCount">{count}</span>
                  </button>
                );
              })}
            </div>

            <div className="maQualifList">
              {getFilteredEntries().length === 0 ? (
                <div className="maQualifEmpty">
                  <i className="bi bi-inbox" /> Aucun contact dans cette
                  catégorie.
                </div>
              ) : (
                getFilteredEntries().map((entry) => (
                  <div key={entry._id} className="maQualifRow">
                    <div className="maQualifRowInfo">
                      <i
                        className={`bi ${CANAL_ICON_MAP[{ nbAppel: 1, nbWhatsapp: 2, nbMessage: 3 }[entry.field]]}`}
                      />
                      <div>
                        <div className="maQualifRowLabel">
                          {buildEntryQuestion(entry.field, entry)}
                        </div>
                        <div className="maQualifRowCount">
                          Le {new Date(entry.date).toLocaleDateString("fr-FR")}{" "}
                          à{" "}
                          {new Date(entry.date).toLocaleTimeString("fr-FR", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </div>
                      </div>
                    </div>

                    <div className="maQualifRowActions">
                      <button
                        className={`maQualifBtnSmall success ${entry.statutQualification === 1 ? "active" : ""}`}
                        onClick={() =>
                          handleQualifyEntry(entry.field, entry._id, 1)
                        }
                      >
                        <i className="bi bi-check-circle" /> Confirmé
                      </button>
                      <button
                        className={`maQualifBtnSmall danger ${entry.statutQualification === 2 ? "active" : ""}`}
                        onClick={() =>
                          handleQualifyEntry(entry.field, entry._id, 2)
                        }
                      >
                        <i className="bi bi-x-circle" /> Non confirmé
                      </button>
                    </div>
                  </div>
                ))
              )}
            </div>

            <div className="modal_vendu_actions">
              <button
                className="btn btn_cancel"
                disabled={qualifyingLoading}
                onClick={() => {
                  setShowQualifModal(false);
                  setArticleToQualify(null);
                }}
              >
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
